// 请假状态：唯一来源，LeaveManage / LeaveList / ClassStudents 共用，避免三处各写一份导致文案漂移
// 后端 recordLeave 口径：status 1待审核 / 2审核通过 / 3取消（已取消）。
// 4 保留兼容历史数据，同样映射"已取消"；若后端状态语义不同，只改这里一处
export function leaveStatusText(status) {
  switch (status) {
    case 1: return "待审核";
    case 2: return "已通过";
    case 3: return "已取消";
    case 4: return "已取消";
    default: return "未知";
  }
}

export function leaveStatusType(status) {
  switch (status) {
    case 1: return "warning";
    case 2: return "success";
    case 3: return "default";
    default: return "default";
  }
}
